"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var home_1 = __importDefault(require("./components/home/home"));
var comic_list_wrapper_1 = __importDefault(require("./components/comic/comic-list-wrapper"));
var auth_1 = __importDefault(require("./components/home/auth"));
var four_oh_four_1 = __importDefault(require("./components/four-oh-four/four-oh-four"));
var comic_root_1 = __importDefault(require("./components/comic/comic-root"));
var MainRouter = function (_a) {
    var location = _a.location;
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/", component: home_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/404", component: four_oh_four_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/auth", component: auth_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/comics/", component: comic_list_wrapper_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/:comicSlug/", component: comic_root_1.default }),
        react_1.default.createElement(react_router_dom_1.Redirect, { from: "*", to: "/404" })));
};
exports.default = MainRouter;
